export default "__VITE_ASSET__ba5345dc__"